// extracted by mini-css-extract-plugin
export default {"main":"tags_main__2kOCi","text":"tags_text__yTGi7","selectBoxEllipses":"tags_selectBoxEllipses__zA0Cw"};